export default {
    requirements: {
        low: {
            id: 'low',
            name: 'Low',
            totalFootage: 100,
            staffing: 1,
            staffingCode: "da",
            equipment: [],
            software: [],
            otherItems: []
        },

        medium: {
            id: 'medium',
            name: 'Medium',
            totalFootage: 200,
            staffing:1.5,
            staffingCode: "da",
            equipment: [],
            software: [],
            otherItems: []
        },

        high: {
            id: 'high',
            name: 'High',
            totalFootage: 300,
            staffing: 2,
            staffingCode: "da",
            equipment: [],
            software: [],
            otherItems: []
        },
    },

    ratingDetails: [
        {
            id: 'level',
            type: 'enum',
            required: false,
            component: 'PulloutQuestionMultiSwitchList',
            default: 0,
            label: "Level of Need:",
            options: [
                {
                    id: "none",
                    label: "None",
                    value: 0
                },

                {
                    id: "low",
                    label: "Low",
                    description: "up to 100 jobs per/yr",
                    value: 1
                },
                {
                    id: "medium",
                    label: "Medium",
                    description: "up to 200 jobs per/yr",
                    value: 2
                },
                {
                    id: "high",
                    label: "High",
                    description: "up to 300 jobs per/yr",
                    value: 3
                }
            ]
        }

    ]
}
